"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = exports.SkeletonBox = exports.StyledSkeletonBox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const backgroundAnimation = (0, app_1.keyframes) `
0% {
  transform: skew(-25deg) translateX(-100%);
}
100% {
  transform: skew(-25deg) translateX(200%);
}
`;
const spanStyle = (0, app_1.css) `
  width: 100%;
  border-radius: 0.1em;
  position: relative;
  background: #eee;
  overflow: hidden;
  ::before {
    content: '';
    position: absolute;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.6),
      rgba(255, 255, 255, 0)
    );
    width: 85%;
    height: 100%;
    top: 0;
    left: 0;
    animation: ${backgroundAnimation} 1.2s linear infinite;
  }
`;
exports.StyledSkeletonBox = app_1.styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > span {
    ${spanStyle}
    height: 100%;
  }
`;
const StyledSkeleton = app_1.styled.span `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  > span {
    ${spanStyle}
    margin-bottom: 1rem;
  }
  > span:not(:first-child):last-child {
    width: 70%;
  }
  > span:last-child {
    margin-bottom: 0;
  }
`;
const textAlignToCss = {
    right: 'flex-start',
    center: 'center',
    left: 'flex-end',
};
function SkeletonBox({ className, color = 'rgb(189, 189, 189)', }) {
    return ((0, jsx_runtime_1.jsx)(exports.StyledSkeletonBox, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)("span", { css: (0, app_1.css) `
          background: linear-gradient(
            90deg,
            ${(0, utils_1.colorAlpha)(color, 0.3)} 25%,
            ${(0, utils_1.colorAlpha)(color, 0.6)} 36%,
            ${(0, utils_1.colorAlpha)(color, 0.3)} 63%
          );
        ` }) })));
}
exports.SkeletonBox = SkeletonBox;
function Skeleton({ text, rows = 3, lineHeight = '1em', textColor = 'rgb(189, 189, 189)', textAlign = 'right', className, }) {
    return text ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: text })) : ((0, jsx_runtime_1.jsx)(StyledSkeleton, Object.assign({ className: className, css: (0, app_1.css) `
        align-items: ${textAlignToCss[textAlign]};
      ` }, { children: Array.from({ length: rows }).map((_, i) => ((0, jsx_runtime_1.jsx)("span", { css: (0, app_1.css) `
            height: ${lineHeight};
            background: linear-gradient(
              90deg,
              ${(0, utils_1.colorAlpha)(textColor, 0.3)} 25%,
              ${(0, utils_1.colorAlpha)(textColor, 0.6)} 36%,
              ${(0, utils_1.colorAlpha)(textColor, 0.3)} 63%
            );
          ` }, i))) })));
}
exports.Skeleton = Skeleton;
